export { default as LifestylesIndexPageBreadcrumbsItem } from './LifestylesIndexPageBreadcrumbsItem';
